import { z } from 'zod';
import { PaymentSettingsResponseSchema } from './payment-settings.ts';

export const GetPaymentSettingsRequestSchema = z.object({
    orders: z.array(
        z.object({
            orderId: z.string().uuid(),
            organizationIds: z.array(z.number()),
        })
    ),
});

export const GetPaymentSettingsResponseSchema = z.object({
    organizations: z.array(
        z.object({
            orderId: z.string().uuid(),
            orgId: z.number(),
            financeSettings: z.array(PaymentSettingsResponseSchema),
        })
    ),
});

export type GetPaymentSettingsResponse = z.infer<typeof GetPaymentSettingsResponseSchema>;
